// application
import { AxiosResponse } from "axios";
import { UserResponse } from "@models/response";
import { LoginRequest } from "@models/request";
import { Result } from "@/main/models/common/resultResponse";

export abstract class IAuthApi {
	abstract loginApi(request: LoginRequest): Promise<AxiosResponse<Result<UserResponse>>>;
	abstract verifyIfExistsUserLoggedIn(username: string): Promise<AxiosResponse<Result<boolean>>>;
	abstract logout(): Promise<AxiosResponse<Result<void>>>;
}
